export enum FieldName {
    name = 'name',
    dates = 'dates',
    location = 'location',
    invoiceReference = 'invoiceReference',
    comment = 'comment',
    customer = 'customer',
}
